import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/theme.css';
import { fetchSettings } from '../lib/settings';
import { FacebookIcon, InstagramIcon, LinkedinIcon } from './icons';

export default function MobileMenu({ open, onClose }) {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let mounted = true;
    fetchSettings()
      .then((s) => { if (mounted) setSettings(s); })
      .catch(() => { });
    return () => { mounted = false; };
  }, []);

  const resolve = (obj, keys = []) => {
    for (const k of keys) {
      const v = obj?.[k];
      if (typeof v === 'string' && v.trim()) return v.trim();
    }
    return '';
  };
  const ensureHttp = (url) => {
    if (!url) return '';
    return /^(https?:)?\/\//i.test(url) ? url : `https://${url}`;
  };

  const fbUrl = ensureHttp((settings?.socials?.facebook) || resolve(settings, ['facebook', 'facebook_url', 'fb', 'facebookLink', 'url_facebook', 'reseaux_facebook']));
  const igUrl = ensureHttp((settings?.socials?.instagram) || resolve(settings, ['instagram', 'instagram_url', 'ig', 'instagramLink', 'url_instagram', 'reseaux_instagram']));
  const lnUrl = ensureHttp((settings?.socials?.linkedin) || resolve(settings, ['linkedin', 'linkedin_url', 'ln', 'linkedinLink', 'url_linkedin', 'reseaux_linkedin']));

  return (
    <div className={"mobile-drawer " + (open ? 'open' : '')} aria-hidden={!open}>
      <div className="mobile-backdrop" onClick={onClose} />
      <div className="mobile-panel">
        <div className="mobile-head">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src="/logo192.png" alt="AEF" style={{ height: 28 }} />
            <div style={{ fontWeight: 800 }}>AEF</div>
          </div>
          <button className="btn ghost" onClick={onClose} aria-label="Fermer">Fermer</button>
        </div>
        <nav className="mobile-nav">
          <NavLink to="/" onClick={onClose} end>Accueil</NavLink>
          <NavLink to="/services" onClick={onClose}>Services</NavLink>
          <NavLink to="/realisations" onClick={onClose}>Réalisations</NavLink>
          <NavLink to="/catalogue" onClick={onClose}>Catalogue</NavLink>
          <NavLink to="/agenda" onClick={onClose}>Agenda</NavLink>
          <NavLink to="/qui-sommes-nous" onClick={onClose}>Qui sommes-nous</NavLink>
          <NavLink to="/contact" onClick={onClose}>Contact</NavLink>
          <div style={{ marginTop: 12, display: 'grid', gap: 8 }}>
            <NavLink
              to="/contact"
              onClick={onClose}
              className="btn ghost"
            >
              Prendre rendez-vous
            </NavLink>
            <NavLink
              to="/contact"
              onClick={onClose}
              className="btn filled"
            >
              Devis gratuit
            </NavLink>
          </div>
          <div style={{ marginTop: 24, padding: '0 12px', display: 'flex', gap: 20, justifyContent: 'center', borderTop: '1px solid #eef0f2', paddingTop: 20 }}>
            {fbUrl && (
              <a href={fbUrl} target="_blank" rel="noreferrer" style={{ color: '#64748b' }}>
                <FacebookIcon size={24} />
              </a>
            )}
            {igUrl && (
              <a href={igUrl} target="_blank" rel="noreferrer" style={{ color: '#64748b' }}>
                <InstagramIcon size={24} />
              </a>
            )}
            {lnUrl && (
              <a href={lnUrl} target="_blank" rel="noreferrer" style={{ color: '#64748b' }}>
                <LinkedinIcon size={24} />
              </a>
            )}
          </div>
        </nav>
      </div>
    </div>
  );
}
